import { FormFieldTypes } from "../../../data/formFieldType";

export const ViewGMPCourseFormData = {
    name: "ViewGMPCourseFormData",
    initialState: {
        organisationName: "",
        uENNumber: ""
    },
    formFields: [
        {
            id: "uENNumber",
            lable: "Search by Organisation UEN",
            Field_Name: "Search by Organisation UEN",
            fieldType: FormFieldTypes.INPUT,
            dataField: "uENNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 mb-2",
            },
        },
        {
            id: "organisationName",
            lable: "Search by Organisation Name",
            Field_Name: "Search by Organisation Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "organisationName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 mb-2",
            },
        },


    ],
    formSetting: {
        isViewOnly: false,
    },
};